import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';

function useIsMobileView() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down('md'));
}

export default useIsMobileView;
